<script setup lang="ts">
import { useTutorApplicationStore } from '../model/store'
import FormBox from './FormBox.vue'
import UploadCoverLetter from './cover-letter/UploadCoverLetter.vue'

defineOptions({
  name: 'CoverLetter',
})

const tutorApplicationStore = useTutorApplicationStore()

const uploadCoverLetterRef = useTemplateRef<InstanceType<typeof UploadCoverLetter>>('uploadCoverLetterRef')

const setClear = (): void => {
  tutorApplicationStore.resetCoverLetter()
  uploadCoverLetterRef.value?.resetFiles()
}

</script>

<template>
  <FormBox
    title="Cover letter"
    @click:clear="setClear"
  >
    <div class="cover-letter__upload">
      <UploadCoverLetter
        ref="uploadCoverLetterRef"
      />
    </div>
  </FormBox>
</template>
